import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

interface PurchaseAutoQuoteRequest {
  product_id: string;
  quantity?: number;
  include_sample?: boolean;
}

interface PurchaseAutoQuoteResponse {
  stripe_payment_link: string;
  payment_intent_id: number;
}

export const purchaseAutoQuote = async (
  body: PurchaseAutoQuoteRequest
): Promise<PurchaseAutoQuoteResponse> => {
  try {
    const response = await apiService.post<PurchaseAutoQuoteResponse>(
      '/payment-intents/auto-quote/',
      body
    );

    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default purchaseAutoQuote;
